import * as React from 'react'
import cx from 'classnames'

// Components
import StepFooter from './StepFooter'
import { Button } from '@metrisk/react_metrisk-components'

// Styles
import './Step.scss'

const Step = ({ id, currentStep, footer, children }: any) => {
  return (
    <section className={cx('step', { 'step--active': id === currentStep })} id={id}>
      {children}
      <StepFooter {...footer} />
    </section>
  )
}

export default Step
